// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumb_breadcrumbs__TfvaH","link_area":"breadcrumb_link_area__cw1fX","link":"breadcrumb_link__9kSTZ"};